import { GenericField, InputProps } from "../Fields/GenericField";
import { useField } from "formik";
import { Rating } from "@/lib/Components/Rating/Rating";

export type RatingInputProps = InputProps & {
  onChange?: (value: number) => void;
  maxRating?: number;
  size?: "sm" | "md" | "lg";
  showValue?: boolean;
};

export function RatingInput({
  onChange,
  maxRating = 5,
  size = "md",
  showValue = false,
  ...props
}: RatingInputProps) {
  const [{ value }, , { setValue }] = useField<number>(props.name);

  const handleRatingChange = async (rating: number) => {
    await setValue(rating);
    onChange?.(rating);
  };

  return (
    <GenericField
      viewNode={
        <Rating
          rating={value}
          maxRating={maxRating}
          readonly
          size={size}
          showValue={showValue}
        />
      }
      {...props}
    >
      <Rating
        rating={value}
        maxRating={maxRating}
        onRatingChange={handleRatingChange}
        size={size}
        showValue={showValue}
      />
    </GenericField>
  );
}
